import { render, staticRenderFns } from "./LsportDetailPrice.vue?vue&type=template&id=2186b96c&scoped=true"
import script from "./LsportDetailPrice.vue?vue&type=script&lang=js"
export * from "./LsportDetailPrice.vue?vue&type=script&lang=js"
import style0 from "./LsportDetailPrice.vue?vue&type=style&index=0&id=2186b96c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2186b96c",
  null
  
)

export default component.exports